import { EntitledToView } from '@news-mono/web-common'
import React from 'react'
import {
    StyledFootyLivesHereLink,
    StyledFootyLivesHerePromoCard,
    StyledPromoImg,
} from './FootyLivesHerePromoCard.styled'

export const EntitledView = () => {
    const promo = require('./assets/2025-AFL-Origin-Guernsey-Giveaway-Logged-In.jpg')

    return (
        <StyledFootyLivesHerePromoCard>
            <StyledPromoImg
                src={promo}
                alt="Your season of AFL. 2026 AFL AAMI Origin Guide available 13th February. AFL Season Preview Guide available 4th March."
            />
        </StyledFootyLivesHerePromoCard>
    )
}
export const OpportunityView: React.FC = () => {
    const promo = require('./assets/2025-AFL-Origin-Guernsey-Giveaway-Logged-Out.jpg')

    return (
        <StyledFootyLivesHerePromoCard>
            <StyledFootyLivesHereLink to="/sport/afl/subscribe">
                <StyledPromoImg
                    src={promo}
                    alt="Get a 12 month subscription to The West and receive a FREE WA AAMI AFL Origin Guernsey"
                />
            </StyledFootyLivesHereLink>
        </StyledFootyLivesHerePromoCard>
    )
}

export const FootyLivesHerePromoCard: React.FC = () => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView />
            }}
            notEntitled={() => {
                return <OpportunityView />
            }}
        />
    )
}
